export default __webpack_public_path__ + "9c0ce9db49711cddcd7edb8a4fb7e2ff.png";